<template>
    <div class="finance-page withdraw-page">
        <div class="finance-page__inner">
            <header class="finance-hero">
                <div class="finance-hero__icon finance-hero__icon--out" aria-hidden="true">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 5v14M7 10l5-5 5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div>
                    <h1 class="finance-hero__title">{{ $t('withdraw.withdraw_form') }}</h1>
                    <p class="finance-hero__subtitle">
                        {{ $store.state.language === 'en'
                            ? 'Funds will be sent to your saved bank account. Minimum withdrawal applies.'
                            : 'သိမ်းဆည်းထားသော ဘဏ်အကောင့်သို့ ပို့ပေးမည်။ အနည်းဆုံး ထုတ်ယူမှုပမာဏ ရှိသည်။' }}
                    </p>
                </div>
            </header>

            <div v-if="error" class="finance-alert finance-alert--error" role="alert">
                {{ error }}
            </div>

            <div v-if="balanceDisplay !== null" class="finance-balance-strip">
                <span class="finance-balance-strip__label">
                    {{ $store.state.language === 'en' ? 'Available balance' : 'လက်ကျန်ငွေ' }}
                </span>
                <span class="finance-balance-strip__value">
                    {{ balanceDisplay }} {{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}
                </span>
            </div>

            <section class="finance-card finance-card--account-select">
                <h2 class="finance-card__label">
                    {{
                        $store.state.language === 'en'
                            ? 'Withdrawal account'
                            : 'ငွေထုတ်ယူမည့်အကောင့်'
                    }}
                </h2>
                <p class="finance-select-hint">
                    {{
                        $store.state.language === 'en'
                            ? 'Funds are sent to this saved account. Tap edit to update in Banking.'
                            : 'သိမ်းဆည်းထားသော ဤအကောင့်သို့ ငွေပို့ပေးမည်။ ပြင်ဆင်ရန် ဘဏ်စာမျက်နှာသို့ သွားပါ။'
                    }}
                </p>
                <div class="finance-select-shell">
                    <div class="finance-account-readonly">
                        <div class="finance-account-readonly__main">
                            <img
                                v-if="withdrawBankLogo"
                                :src="withdrawBankLogo"
                                alt=""
                                class="finance-account-readonly__logo"
                            >
                            <div class="finance-account-readonly__text">
                                <span class="finance-account-readonly__type">{{ bankInfo.type }}</span>
                                <span class="finance-account-readonly__name">{{ bankInfo.name }}</span>
                                <span class="finance-account-readonly__number">{{
                                    blurLastFiveCharacters(bankInfo.account_number)
                                }}</span>
                            </div>
                        </div>
                        <router-link
                            to="/banking"
                            class="finance-account-readonly__edit"
                            :title="$store.state.language === 'en' ? 'Edit bank' : 'ဘဏ်ပြင်ရန်'"
                        >
                            <img
                                src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/edit.png"
                                alt=""
                            >
                        </router-link>
                    </div>
                </div>
            </section>

            <form class="finance-form" @submit.prevent>
                <section class="finance-card">
                    <label class="finance-label" for="withdraw-amount">{{ $t('withdraw.amount') }}</label>
                    <p class="finance-hint">{{ $t('withdraw.minimum_deposit') }}</p>
                    <input
                        id="withdraw-amount"
                        type="number"
                        inputmode="decimal"
                        class="finance-input"
                        v-model="withdrawData.amount"
                        :placeholder="$store.state.language === 'en' ? 'Amount in MMK' : 'ငွေပမာဏ'"
                    />
                    <p v-if="errors.amount" class="finance-field-error">{{ errors.amount }}</p>
                </section>

                <section class="finance-card">
                    <label class="finance-label" for="withdraw-remark">{{ $t('withdraw.remark') }}</label>
                    <p class="finance-hint">
                        {{ $store.state.language === 'en'
                            ? 'Optional note for support (e.g. preferred time).'
                            : 'အကူအညီအတွက် မှတ်ချက် (လိုအပ်ပါက)။' }}
                    </p>
                    <textarea
                        id="withdraw-remark"
                        rows="4"
                        class="finance-textarea"
                        v-model="withdrawData.remark"
                        :placeholder="$store.state.language === 'en' ? 'Remarks…' : 'မှတ်ချက်…'"
                    />
                </section>

                <button
                    type="button"
                    class="finance-btn-primary"
                    :disabled="isConfirm"
                    @click="isConfirm ? null : sendWithdrawData()"
                >
                    <Loading v-if="isConfirm" color="#0d0d0d" size="24" class="finance-btn-primary__spin"/>
                    <span v-else>{{ $t('withdraw.submit') }}</span>
                </button>
            </form>
        </div>
    </div>
</template>
<script>
import { Toast, Loading } from 'vant';
import { showStyledAppAlert } from '@/utils/showGameUrlErrorDialog';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      bankInfo: {},
      accounts: [
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ Mobile Banking',
          id: 'KBZ Mobile Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kbz.png',
        },
        {
          name: 'Wave pay',
          id: 'Wave pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
        {
          name: 'CB Pay',
          id: 'CB Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/cb_pay.png',
        },
        {
          name: 'CB Banking',
          id: 'CB Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/cbbank.png',
        },
        {
          name: 'AYA Pay',
          id: 'AYA Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/ayapay.png',
        },
        {
          name: 'AYA Banking',
          id: 'AYA Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },

      ],
      account: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
      error: null,
    };
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
    balanceDisplay() {
      const a = this.$store.state.amount;
      if (a === undefined || a === null || a === '') return null;
      const n = Number(a);
      if (Number.isNaN(n)) return null;
      return n.toLocaleString();
    },
    /** Match static logo list to user bank type for same look as deposit picker */
    withdrawBankLogo() {
      if (!this.bankInfo || !this.bankInfo.type) return null;
      const t = String(this.bankInfo.type).toLowerCase();
      const row = this.accounts.find(
        (a) => t.includes(String(a.id).toLowerCase())
          || String(a.id).toLowerCase().includes(t),
      );
      return row ? row.link : null;
    },
  },
  methods: {
    blurLastFiveCharacters(inputString = '0000000000') {
      const length = inputString.length;
      if (length >= 7) {
        const firstPart = inputString.substring(length - 5, length);
        const blurredCharacters = '*'.repeat(length - 5);
        return blurredCharacters + firstPart;
      }
      return inputString;
    },
    ...mapActions(['fetchUser']),
    async sendWithdrawData() {
      try {
        this.isConfirm = true;
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.withdrawData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          this.isConfirm = false;
          return false;
        }
        if (this.withdrawData.amount < 10000) {
          this.errors.amount = this.$t('withdraw.enter_at_least');
          this.isConfirm = false;
          return false;
        }
        if (this.withdrawData.amount > parseInt(authUser.amount, 10)) {
          const balanceError = this.$store.state.language === 'en'
            ? "You Don't Have Sufficient Balance"
            : 'အကောင့်ထဲတွင် ပိုက်ဆံအလုံအလောက် မရှိပါ။';
          const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
          showStyledAppAlert(balanceError, lang, {
            confirmButtonText:
              lang === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isConfirm = false;
          return false;
        }
        this.$store.commit(
          'setAmount',
          (this.$store.state.amount -= this.withdrawData.amount),
        );

        if (this.imageUploader[0]) {
          this.withdrawData.transaction_image = this.imageUploader[0].content;
        }
        this.withdrawData.date = this.currentTime;
        this.withdrawData.account_number = this.bankInfo.account_number;
        this.withdrawData.account_name = this.bankInfo.name;
        this.withdrawData.type = this.bankInfo.type;
        this.withdrawData.lang = localStorage.getItem('language');

        await axios.post('/withdraws', this.withdrawData, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
              });
        await axios.post(
          `/admin/user/${this.$store.state.authUser.id}`,
          {
            amount: this.withdrawData.amount,
            type: 'withdraw',
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          },
        );
        this.imageUploader = [];
        this.withdrawData = {};
        this.selected_account.account_id = null;
        await this.fetchUser();
        Toast.success('Success');
        this.isConfirm = false;
      } catch (error) {
        Toast.fail('Fail');
        this.error = error.response.data;
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
      return;
    }
    if (!authUser.bank.account_number || !authUser.bank.name) {
      this.$router.push('/banking');
      return;
    }
    this.bankInfo = authUser.bank;
  },
};
</script>
<style scoped>
.withdraw-page {
  --finance-accent: rgb(240, 97, 38);
  --finance-accent-soft: rgba(240, 97, 38, 0.22);
  --finance-surface: #141414;
  --finance-surface-2: #1a1a1a;
  --finance-text: #e8e8e8;
  --finance-muted: #9a9a9a;
  --finance-radius: 14px;
}

.finance-page {
  box-sizing: border-box;
  min-height: 100vh;
  overflow-y: visible;
  padding-top: calc(1.35rem + env(safe-area-inset-top, 0px));
  padding-bottom: calc(9.5rem + env(safe-area-inset-bottom, 0px));
  padding-left: 1rem;
  padding-right: 1rem;
  margin-top: 0.35rem;
  margin-bottom: 0.5rem;
  background:
    radial-gradient(ellipse 80% 50% at 80% -15%, rgba(100, 180, 255, 0.08), transparent),
    radial-gradient(ellipse 60% 40% at 10% 0%, rgba(240, 97, 38, 0.12), transparent),
    linear-gradient(180deg, #0c0c0c 0%, #101010 45%, #0a0a0a 100%);
  -webkit-overflow-scrolling: touch;
}

.finance-page__inner {
  max-width: 520px;
  margin: 0 auto;
}

.finance-hero {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.finance-hero__icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--finance-surface);
  border: 1px solid var(--finance-accent-soft);
  color: var(--finance-accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.finance-hero__icon--out {
  color: #7eb8ff;
  border-color: rgba(126, 184, 255, 0.25);
}

.finance-hero__title {
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--finance-text);
  margin: 0 0 0.35rem;
  letter-spacing: -0.02em;
}

.finance-hero__subtitle {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: var(--finance-muted);
}

.finance-alert {
  border-radius: var(--finance-radius);
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.finance-alert--error {
  background: rgba(220, 53, 69, 0.12);
  border: 1px solid rgba(220, 53, 69, 0.35);
  color: #ffb4b4;
}

.finance-balance-strip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1.1rem;
  margin-bottom: 1rem;
  border-radius: var(--finance-radius);
  background: linear-gradient(90deg, rgba(240, 97, 38, 0.12) 0%, rgba(20, 20, 20, 0.9) 100%);
  border: 1px solid var(--finance-accent-soft);
}

.finance-balance-strip__label {
  font-size: 0.8rem;
  color: var(--finance-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.finance-balance-strip__value {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.finance-card {
  background: var(--finance-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: var(--finance-radius);
  padding: 1.1rem 1.15rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
}

.finance-card--accent {
  border-color: var(--finance-accent-soft);
}

.finance-card__label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--finance-muted);
  margin: 0 0 0.45rem;
}

.finance-select-hint {
  margin: 0 0 0.65rem;
  font-size: 0.76rem;
  line-height: 1.45;
  color: var(--finance-muted);
}

.finance-select-shell {
  position: relative;
  border-radius: 14px;
  padding: 2px;
  background: linear-gradient(
    135deg,
    rgba(126, 184, 255, 0.22) 0%,
    rgba(255, 255, 255, 0.06) 42%,
    rgba(240, 97, 38, 0.22) 100%
  );
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
}

.finance-account-readonly {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  min-height: 54px;
  padding: 0.45rem 0.55rem 0.45rem 0.65rem;
  border-radius: 12px;
  background: linear-gradient(180deg, #161616 0%, #0c0c0c 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.finance-account-readonly__main {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  flex: 1;
}

.finance-account-readonly__logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  padding: 3px;
}

.finance-account-readonly__text {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  min-width: 0;
}

.finance-account-readonly__type {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--finance-muted);
}

.finance-account-readonly__name {
  font-size: 0.92rem;
  font-weight: 600;
  color: #f2f2f2;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.finance-account-readonly__number {
  font-size: 0.82rem;
  color: #b0b0b0;
  letter-spacing: 0.05em;
  font-variant-numeric: tabular-nums;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.finance-account-readonly__edit {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.finance-account-readonly__edit img {
  height: 1.35rem;
  width: auto;
}

.finance-account-readonly__edit:hover {
  background: rgba(240, 97, 38, 0.12);
  border-color: rgba(240, 97, 38, 0.35);
}

.finance-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.finance-label {
  display: block;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--finance-text);
  margin-bottom: 0.25rem;
}

.finance-hint {
  margin: 0 0 0.6rem;
  font-size: 0.78rem;
  color: var(--finance-muted);
  line-height: 1.4;
}

.finance-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #0a0a0a;
  color: #fff;
  font-size: 1.1rem;
  text-align: center;
  box-shadow: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.finance-input:focus {
  outline: none;
  border-color: var(--finance-accent-soft);
  box-shadow: 0 0 0 3px rgba(240, 97, 38, 0.15);
}

.finance-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #0a0a0a;
  color: #fff;
  font-size: 0.95rem;
  line-height: 1.5;
  text-align: left;
  resize: vertical;
  min-height: 100px;
  box-shadow: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.finance-textarea:focus {
  outline: none;
  border-color: var(--finance-accent-soft);
  box-shadow: 0 0 0 3px rgba(240, 97, 38, 0.15);
}

.finance-field-error {
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  color: #6fcf97;
}

.finance-btn-primary {
  margin-top: 0.25rem;
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(180deg, #ff8c42 0%, var(--finance-accent) 55%, #c94a18 100%);
  color: #0d0d0d;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.02em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(240, 97, 38, 0.35);
  transition: opacity 0.2s ease, transform 0.1s ease;
}

.finance-btn-primary:disabled {
  opacity: 0.75;
  cursor: wait;
}

.finance-btn-primary:active:not(:disabled) {
  transform: scale(0.99);
}

.finance-btn-primary__spin {
  padding: 0 !important;
}
</style>
